<template>
  <modal class="modal" name="local-radio-modal" transition="pop-out" :width="modalWidth" height="auto" :scrollable="true" :adaptive="true " :clickToClose="false"
         @before-open="beforeOpen">
    <div class="flex flex-column items-center justify-center">
      <div class="flex justify-end w-100">
        <a @click="closeModal" class="pa3 pointer textColor">
          <font-awesome-icon icon="times" size="2x"/>
        </a>
      </div>
      <div class="radio-content">
        <h2 class="text-center">{{ radio.name }}</h2>
        <img class="radio-picture db" :src="radio.picture" :alt="radio.name">
        <div class="text-center radio-info">
          <span v-if="radio.category">{{ $t('localContent.category') }}: {{ radio.category }} / </span>
          <span v-if="radio.dial">Dial: {{ radio.dial }}</span>
        </div>
      </div>
      <div class="flex items-center bg-primary iframeDiv">
        <video controls="" autoplay="" name="media"><source :src="radio.link" type="audio/mpeg"></video>
      </div>
    </div>
  </modal>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

const MODAL_WIDTH = 500

export default {
  name: 'local-radio-modal',
  components: {
    FontAwesomeIcon,
    ClipLoader
  },
  data () {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '30px',
      radio: {
        link: '',
        name: '',
        picture: '',
        category: '',
        dial: ''
      }
    }
  },
  computed: {
  },
  created () {
    this.modalWidth = window.innerWidth < MODAL_WIDTH
      ? MODAL_WIDTH / 2
      : MODAL_WIDTH
  },
  methods: {
    closeModal () {
      this.$modal.hide('local-radio-modal')
    },
    beforeOpen (event) {
      if (event.params) {
        this.radio.link = event.params.radioUrl
        this.radio.name = event.params.radioName
        this.radio.picture = event.params.radioPicture
        this.radio.category = event.params.radioCategory
        this.radio.dial = event.params.radioDial
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .modal {
    z-index: 10000;
  }

  video {
    height: 30px !important
  }

  .iframeDiv {
    width: 99%;
  }

  .radio-picture {
    line-height: 0;
    height: 100px;
    object-fit: cover;
    width: 100px;
    border-radius: 100px;
  }

  .text-center {
    text-align: center;
  }

  .radio-info {
    font-size: 20px;
    padding: 10px 0px;
  }

  .radio-content {
    display: flex;
    align-content: center;
    align-items: center;
    flex-direction: column;
  }

</style>



// WEBPACK FOOTER //
// src/components/modals/LocalRadioModal.vue